// Simplified: Custom fields are now flattened to top-level
export function buildUpdatePayload(field: string, value: unknown) {
  return { [field]: value };
}

export function applyFieldUpdate<T>(
  entity: T,
  field: string,
  value: unknown,
): T {
  // Simplified: Direct field assignment (custom fields flattened)
  return { ...entity, [field]: value } as T;
}
